import HttpRequest from './core/http_request';

class KokwatchProvider extends HttpRequest {
  // public service
  // env heavy metal survey
  saveEnvHeavyMetalSurveyPublic (data) {
    return this.request('post', '/public/survey/kokwatch/surveyEnvHeavyMetal', data);
  }

  getEnvHeavyMetalSurveyList (data) {
    return this.request('get', '/public/survey/kokwatch/surveyEnvHeavyMetal/list', data);
  }

  getEnvHeavyMetalSurveyPublicByRefId (data) {
    return this.request('get', '/public/survey/kokwatch/surveyEnvHeavyMetal/' + data.refId);
  }

  updateEnvHeavyMetalSurveyPublic (data) {
    const refId = data.refId;
    delete data.refId;
    return this.request('post', '/public/survey/kokwatch/surveyEnvHeavyMetal/' + refId, data);
  }

  deleteEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/public/survey/kokwatch/surveyEnvHeavyMetal/delete/' + _id, data);
  }

  getEnvHeavyMetalSurveyListMapPublic (data) {
    return this.request('get', '/public/survey/kokwatch/surveyEnvHeavyMetal/map', data);
  }

  updateStatusEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/public/survey/kokwatch/surveyEnvHeavyMetal/researcher/status/' + _id, data);
  }
  
  cancelStatusEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/public/survey/kokwatch/surveyEnvHeavyMetal/researcher/cancel/' + _id, data);
  }

  updateResultLabEnvHeavyMetalSurvey (data) {
    return this.request('post', '/public/survey/kokwatch/surveyEnvHeavyMetal/researcher/lab', data);
  }

  updateReceiptEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/public/survey/kokwatch/surveyEnvHeavyMetal/receipt/' + _id, data);
  }
  // end env heavy metal survey

  getExternalLabDataPublic (data) {
    return this.request('get', '/public/survey/kokwatch/externalLabData', data);
  }

  // water quality survey
  saveWaterQualitySurveyPublic (data) {
    return this.request('post', '/public/survey/kokwatch/waterQuality', data);
  }

  getWaterQualitySurveyListPublic (data) {
    return this.request('get', '/public/survey/kokwatch/waterQuality', data);
  }

  updateWaterQualitySurveyPublic (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/public/survey/kokwatch/waterQuality/id/' + _id, data);
  }

  getWaterQualitySurveyByIdPublic (data) {
    return this.request('get', '/public/survey/kokwatch/waterQuality/id/' + data._id);
  }

  deleteWaterQualitySurveyPublic (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/public/survey/kokwatch/waterQuality/delete/id/' + _id, data);
  }

  saveWaterQualitySample (data) {
    const id = data.id;
    delete data.id;
    return this.request('post', '/public/survey/kokwatch/waterQuality/submitSample/id/' + id, data);
  }

  deleteWaterQualitySample (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/public/survey/kokwatch/waterQuality/deleteSample/id/' + _id, data);
  }
  // end water quality survey
}

export default KokwatchProvider;
